<div class="flex flex-col justify-between items-start">
  <div
    *ngrxLet="devicesList$ as devices"
    class="tiles flex flex-row gap-[8px] justify-start items-center"
  >
    <ng-container *ngIf="devices.length">
      <ng-container *ngFor="let device of devices; trackBy: trackBy">
        <div
          (click)="selectDevice(device)"
          gtm="onSelectDevice"
          gtmAction="Remote diagnostics overlay"
          gtmCategory="gatewayDevices"
          data-at-select-device-installation
          class="tile flex flex-col justify-between items-start"
          [class.tile-active]="
            urlDeviceSerial === device?.boilerSerial || (device.isSelected && device.isStandalone)
          "
          [class.tile-disabled]="disabled"
          [class.tile-no-serial]="!device?.boilerSerial"
        >
          <ng-container *ngIf="isEcoWaterDevice(device); else commonInstallation">
            <div class="device-details">
              <ng-container
                *ngIf="
                  (getDeviceVariantFeature(device) | async | ready)?.properties?.value
                    ?.value as deviceVariant;
                  else showDefaultTitle
                "
              >
                <span class="device-title">{{
                  deviceVariant | translateEcowaterDeviceVariant
                }}</span>
              </ng-container>
              <ng-template #showDefaultTitle>
                <span class="device-title">{{
                  '+INSTALLATIONS.INSTALLATIONS.ECOWATER.ECOWATER_TITLE' | translate
                }}</span>
              </ng-template>
            </div>
          </ng-container>

          <ng-template #commonInstallation>
            <div class="flex flex-row">
              <div class="device-img-wrapper">
                <ng-container *ngIf="device?.isStandalone; else showCommonInstallationImage">
                  <img src="/assets/img/devices/standalone.png" class="device-img" />
                </ng-container>
                <ng-template #showCommonInstallationImage>
                  <ng-container *ngIf="device?.deviceImage; else hideImage">
                    <img [src]="device.deviceImage" class="device-img" />
                  </ng-container>
                  <ng-template #hideImage>
                    <mat-icon class="hide-image">hide_image</mat-icon>
                  </ng-template>
                </ng-template>
              </div>

              <div class="device-details flex flex-col justify-center items-start">
                <div class="flex flex-col justify-start items-start">
                  <ng-container *ngIf="device?.isStandalone; else showCommonInstallationName">
                    <span class="device-title">{{
                      '+INSTALLATIONS.INSTALLATION.BASIC_CONTROL.COMMISSIONING_MANAGER.TITLE'
                        | translate
                    }}</span>
                  </ng-container>
                  <ng-template #showCommonInstallationName>
                    <span class="device-title">{{ device?.shortDeviceName }}</span>
                  </ng-template>
                  <span id="data-at-select-device-serial" class="device-serial">{{
                    device?.boilerSerial ?? NO_VALUE
                  }}</span>
                </div>
              </div>
            </div>
          </ng-template>
          <app-aggregated-status-pill
            [gatewaySerial]="device.gatewaySerial"
          ></app-aggregated-status-pill>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
